import { observer } from 'mobx-react';
import {
  redirectToOnboardingIntroduction,
  redirectToDeviceAuthorization,
  redirectToOnboardingProfessionalMonitoring,
  redirectToSettings,
} from '$src/utils/redirect';
import useStores from '$src/hooks/useStores';
import useQuery from '$src/hooks/useQuery';
import { sendCloudwatchRUMError } from '$src/utils/cloudwatchRUM';

function ReturnTo() {
  const { sessionStore } = useStores();

  const searchParams = useQuery();
  const parameters = {
    from: searchParams.from,
    status: searchParams.status,
    userId: searchParams.user_id,
    locationId: searchParams.location_id,
  };

  // eslint-disable-next-line
  if (sessionStore.user?.user_id != parameters.userId) {
    setTimeout(sessionStore.onLogout);
    return null;
  }

  switch (parameters.from) {
    case 'professional_monitoring':
      if (parameters.status === 'ineligible') {
        redirectToOnboardingProfessionalMonitoring(parameters.locationId, {
          error: {
            message: 'We were unable to set up Virtual Security Guard. Please try again.',
            type: 'error',
          },
        });
      } else {
        redirectToOnboardingIntroduction(parameters.locationId);
      }
      break;
    case 'emergency_contacts':
    case 'monitoring_type':
      redirectToSettings(parameters.locationId);
      break;
    default:
      sendCloudwatchRUMError(
        `There was an issue redirecting from RS to VSG CC. An unsupported from parameter was detected: ${parameters.from}`,
        parameters,
      );
      redirectToDeviceAuthorization(parameters.locationId);
  }

  return null;
}

export default observer(ReturnTo);
